<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="19.5" height="19.5" viewBox="0 0 19.5 19.5">
		<path
			id="Path_32857"
			data-name="Path 32857"
			d="M2.25,12A9.75,9.75,0,1,1,12,21.75,9.75,9.75,0,0,1,2.25,12Zm14.024-.983a1.125,1.125,0,0,1,0,1.966l-5.6,3.113A1.125,1.125,0,0,1,9,15.113V8.887A1.125,1.125,0,0,1,10.671,7.9Z"
			transform="translate(-2.25 -2.25)"
			fill="#5d5ee1"
			fill-rule="evenodd"
		/>
	</svg>
</template>

<script>
export default {
	name: 'GuidedTutorialSvg',
};
</script>

<style scoped lang="scss"></style>
